/**
 * @generated SignedSource<<d340e85d0126ec7bd9888f1cc6ab62f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectBudgetFinancial_project$data = {
  readonly id: number;
  readonly is_template: boolean;
  readonly other_costs: ReadonlyArray<{
    readonly charge: number;
    readonly cost: number;
    readonly id: number;
  }>;
  readonly pricing_model: string;
  readonly project_rates: ReadonlyArray<{
    readonly rate: number | null | undefined;
    readonly role_id: number;
  }>;
  readonly project_roles: ReadonlyArray<{
    readonly estimated_minutes: number | null | undefined;
    readonly id: number;
    readonly role_id: number;
  }>;
  readonly summary: ReadonlyArray<{
    readonly role_id: number | null | undefined;
    readonly total_billable_minutes: number | null | undefined;
    readonly total_nonbillable_minutes: number | null | undefined;
  }>;
  readonly total_budget: number | null | undefined;
  readonly " $fragmentType": "ProjectBudgetFinancial_project";
};
export type ProjectBudgetFinancial_project$key = {
  readonly " $data"?: ProjectBudgetFinancial_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectBudgetFinancial_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectBudgetFinancial_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricing_model",
      "storageKey": null
    },
    {
      "alias": "total_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "total_budget_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "v_summary_total",
      "kind": "LinkedField",
      "name": "summary",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_billable_minutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_nonbillable_minutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_roles",
      "kind": "LinkedField",
      "name": "project_roles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimated_minutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_rates",
      "kind": "LinkedField",
      "name": "project_rates",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": "rate",
          "args": null,
          "kind": "ScalarField",
          "name": "rate_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "date": "asc"
          }
        }
      ],
      "concreteType": "other_costs",
      "kind": "LinkedField",
      "name": "other_costs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "charge",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cost",
          "storageKey": null
        }
      ],
      "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "82760611902428d1ea0edf7a20055db1";

export default node;
